export default {
  notFoundTitle: 'Zimmer 404 haben wir leider nicht',
  notFoundLead: 'Diese Seite konnten wir nicht finden. Vielleicht hat sie beim Umbau die Tür gewechselt – oder es hat sich ein Tippfehler in die Adresse geschlichen.',
  notFoundCta: 'Zurück zur Startseite',
  notFoundLinksIntro: 'Vielleicht suchen Sie das hier:',
  notFoundLinkRooms: 'Zimmer und Preise',
  notFoundLinkBooking: 'Verfügbarkeit prüfen',

  legalBack: 'Zurück',

  // Impressum & Datenschutz: gesetzlich vorgegeben (Deutschland) – DE-Original bleibt erhalten.
};
